export interface SdkRequestError {
  response?: {
    status?: number;
  };
  parsedError?: {
    error?: string;
  };
}

export const isUnauthorizedError = (error: unknown): boolean => {
  const sdkError = error as SdkRequestError;

  // Check HTTP status code (401 or 403)
  const status = sdkError?.response?.status;
  const isUnauthorizedStatus = status === 401 || status === 403;

  // Check parsedError for NOT_AUTHORIZED or ACCESS_DENIED
  const errorCode = sdkError?.parsedError?.error;
  const isNotAuthorizedError = errorCode === 'NOT_AUTHORIZED' || errorCode === 'ACCESS_DENIED';

  // Return true only if BOTH conditions are met
  return isUnauthorizedStatus && isNotAuthorizedError;
};
